import script from "./AuthorizationList.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorizationList.vue?vue&type=script&setup=true&lang=js"

import "./AuthorizationList.vue?vue&type=style&index=0&id=7f502030&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f502030"]])

export default __exports__